import * as React from 'react';
import { createContext, useContext } from 'react';
export const CollectionRegisterContext = /*#__PURE__*/ createContext(null);
export const CollectionItemsContext = /*#__PURE__*/ createContext(null);
export const CollectionStateContext = /*#__PURE__*/ createContext(null);
/**
 * This takes a collection returned from `useCollection` and makes it available
 * to all components. You must use this in the top-level component for the
 * system to work; otherwise `useItem` won't be able to register items.
 */ export function CollectionProvider({ collection, state, children }) {
    return /*#__PURE__*/ React.createElement(CollectionStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ React.createElement(CollectionRegisterContext.Provider, {
        value: collection.register
    }, /*#__PURE__*/ React.createElement(CollectionItemsContext.Provider, {
        value: collection.getItems
    }, children)));
}
/**
 * This hook will return all the items.
 */ export function useCollectionItems() {
    var _useContext;
    const items = ((_useContext = useContext(CollectionItemsContext)) === null || _useContext === void 0 ? void 0 : _useContext()) || [];
    return items;
}
export function useCollectionState() {
    const state = useContext(CollectionStateContext);
    if (state == null) {
        throw new Error('Tried to access collection state outside of a collection');
    }
    return state;
}

//# sourceMappingURL=context.js.map